import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { parentalConsentCopy } from '@/Pages/ParentalConsent/copy';
import '@/Pages/ParentalConsent/ParentalConsentPage.sass';

type ConsentCheckboxProps = {
  checked: boolean;
  error?: string;
  showError: boolean;
  onChange: (checked: boolean) => void;
  onBlur: () => void;
};

export function ConsentCheckbox({
  checked,
  error,
  showError,
  onChange,
  onBlur,
}: ConsentCheckboxProps): JSX.Element {
  const hasError = showError && Boolean(error);
  const errorId = 'consentGiven-error';

  return (
    <FormControl
      error={hasError}
      className="guardian-form__consent"
      data-testid="guardian-field-consentGiven"
    >
      <FormControlLabel
        htmlFor="consentGiven"
        control={
          <Checkbox
            id="consentGiven"
            name="consentGiven"
            checked={checked}
            onChange={(_event, nextChecked) => onChange(nextChecked)}
            onBlur={onBlur}
            inputProps={{
              'aria-invalid': hasError,
              'aria-describedby': hasError ? errorId : undefined,
            }}
          />
        }
        label={parentalConsentCopy.consentLabel}
      />
      {hasError ? (
        <FormHelperText id={errorId} role="alert">
          {error}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}
